var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.changelabel),function(item){return _c('el-breadcrumb-item',[_vm._v(_vm._s(item))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }